export default "__VITE_ASSET__BopKFvKQ__"